module.exports = __webpack_public_path__ + "img/hangye.5e054af6.png";